module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Medium.998adaf4.ttf";